module.exports = __webpack_public_path__ + "media/images/icon__email@3x-0f1922d419cbddef0e5e52ac80f1b76f.png";